import SwTransitionExpand from './sw-transition-expand.vue';

export {
  SwTransitionExpand,
};
